export const portfolio_urls = [
  {
      "value": "VFMVSF",
      "label": "VFMVSF - Dragon Capital",
      "id": 4,
      "created_at": "2025-01-06T07:45:37.283706+00:00",
      "fund_code": "VFMVSF",
      "fund_name": "Cổ phiếu Việt Nam",
      "organization_name": "Dragon Capital",
      "status": false,
      "total_asset": 4800,
      "nav": 15614,
      "fee": 0,
      "establish_date": "29/12/2017",
      "stt": 1,
      "url_data": null,
  },
  {
      "value": "DCDS",
      "label": "DCDS - Dragon Capital",
      "id": 8,
      "created_at": "2025-01-06T07:45:37.283706+00:00",
      "fund_code": "DCDS",
      "fund_name": "Chứng khoán năng động",
      "organization_name": "Dragon Capital",
      "status": true,
      "total_asset": 1796,
      "nav": 76579,
      "fee": 0.022,
      "establish_date": "1/4/2004",
      "stt": 2,
      "url_data": 'https://dragoncapitalprod.blob.core.windows.net/cms1public/DCDS_BC_Thang_MM_BCYYYY_BC.xlsx',
      "url_data_ex": 'https://dragoncapitalprod.blob.core.windows.net/cms1public/DCDS_BC_Thang_052025.xlsx'
  },
  {
      "value": "DCDE",
      "label": "DCDE - Dragon Capital",
      "id": 9,
      "created_at": "2025-01-06T07:45:37.283706+00:00",
      "fund_code": "DCDE",
      "fund_name": "Đầu tư DN hàng đầu",
      "organization_name": "Dragon Capital",
      "status": true,
      "total_asset": 502,
      "nav": 28868,
      "fee": 0.023,
      "establish_date": "1/12/2013",
      "stt": 3,
      "url_data": 'https://dragoncapitalprod.blob.core.windows.net/cms1public/DCDE_BC_THANG_MM_BC_YYYY_BC.xlsx',
      "url_data_ex": 'https://dragoncapitalprod.blob.core.windows.net/cms1public/DCDE_BC_THANG_05_2025.xlsx'
  },
  {
      "value": "BMFF",
      "label": "BMFF - MBCapital",
      "id": 14,
      "created_at": "2025-01-06T07:45:37.283706+00:00",
      "fund_code": "BMFF",
      "fund_name": "CP tăng trưởng",
      "organization_name": "MBCapital",
      "status": false,
      "total_asset": 150,
      "nav": 12214,
      "fee": 0,
      "establish_date": "14/2/2023",
      "stt": 4
  },
  {
      "value": "BMVF",
      "label": "BMVF - MBCapital",
      "id": 5,
      "created_at": "2025-01-06T07:45:37.283706+00:00",
      "fund_code": "BMVF",
      "fund_name": "CP Giá trị",
      "organization_name": "MBCapital",
      "status": false,
      "total_asset": 131,
      "nav": 21190,
      "fee": 0.02,
      "establish_date": "25/4/2014",
      "stt": 5
  },
  {
      "value": "TCEF",
      "label": "TCEF - Techcombank Fund",
      "id": 2,
      "created_at": "2025-01-06T07:45:37.283706+00:00",
      "fund_code": "TCEF",
      "fund_name": "CP rủi ro cao",
      "organization_name": "Techcombank Fund",
      "status": false,
      "total_asset": 343,
      "nav": 0,
      "fee": 0.012,
      "establish_date": "0",
      "stt": 6
  },
  {
      "value": "BCF",
      "label": "BCF - Vietcombank Fund",
      "id": 1,
      "created_at": "2025-01-06T07:45:37.283706+00:00",
      "fund_code": "BCF",
      "fund_name": "CP hàng đầu",
      "organization_name": "Vietcombank Fund",
      "status": true,
      "total_asset": 504,
      "nav": 32510,
      "fee": 0.0218,
      "establish_date": "22/8/2014",
      "stt": 7,
      "url_data": 'https://www.vcbf.com/images/YYYY_UP/vcbfbcf_bc_fms_thang_ky_so__M_BC.rar',
      "url_data_ex": 'https://www.vcbf.com/images/2025/vcbfbcf_bc_fms_thang_ky_so__4.rar'
  },
  {
      "value": "MGF",
      "label": "MGF - Vietcombank Fund",
      "id": 10,
      "created_at": "2025-01-06T07:45:37.283706+00:00",
      "fund_code": "MGF",
      "fund_name": "CP tăng trưởng",
      "organization_name": "Vietcombank Fund",
      "status": true,
      "total_asset": 428,
      "nav": 12122,
      "fee": 0.0218,
      "establish_date": "2/12/2021",
      "stt": 8,
      "url_data": 'https://www.vcbf.com/images/YYYY_BC/vcbfmgf_bc_fms_thang_ky_so__M_BC.rar',
      "url_data_ex": 'https://www.vcbf.com/images/2025/vcbfmgf_bc_fms_thang_ky_so__4.rar',
  },
  {
      "value": "TBF",
      "label": "TBF - Vietcombank Fund",
      "id": 6,
      "created_at": "2025-01-06T07:45:37.283706+00:00",
      "fund_code": "TBF",
      "fund_name": "CP Cân bằng chiến lược",
      "organization_name": "Vietcombank Fund",
      "status": true,
      "total_asset": 284,
      "nav": 30754,
      "fee": 0.0199,
      "establish_date": "24/12/2013",
      "stt": 9,
      "url_data": 'https://www.vcbf.com/images/YYYY_UP/vcbtbf_bc_fms_thang_ky_so__M_BC.rar',
      "url_data_ex": 'https://www.vcbf.com/images/2025/vcbtbf_bc_fms_thang_ky_so__4.rar',
  },
  {
      "value": "VESAF",
      "label": "VESAF - Vina Capital",
      "id": 3,
      "created_at": "2025-01-06T07:45:37.283706+00:00",
      "fund_code": "VESAF",
      "fund_name": "CP Tiếp cận thị trường",
      "organization_name": "Vina Capital",
      "status": true,
      "total_asset": 1663,
      "nav": 28683,
      "fee": 0.0175,
      "establish_date": "18/4/2017",
      "stt": 10,
      "url_data": 'https://vinacapital.com/wp-content/uploads/YYYY_UP/MM_UP/YYYYMMDD_UP_VESAF_FMS_FORM_WORKING_Ky-so_Thang_MM_BCYYYY_BC.xlsx',
      "url_data_ex": 'https://vinacapital.com/wp-content/uploads/2025/06/20250605_VESAF_FMS_FORM_WORKING_Ky-so_Thang_052025.xlsx',
  },
  {
      "value": "VEOF",
      "label": "VEOF - Vina Capital",
      "id": 7,
      "created_at": "2025-01-06T07:45:37.283706+00:00",
      "fund_code": "VEOF",
      "fund_name": "CP Hưng Thịnh",
      "organization_name": "Vina Capital",
      "status": true,
      "total_asset": 784,
      "nav": 28315,
      "fee": 0.0175,
      "establish_date": "1/7/2014",
      "stt": 11,
      "url_data": 'https://vinacapital.com/wp-content/uploads/YYYY_UP/MM_UP/YYYYMMDD_UP_VEOF_FMS-FORM_WORKING_Thang_MM_BC_YYYY_BC_KY-SO_FOR-FILING.xlsx',
      "url_data_ex": 'https://vinacapital.com/wp-content/uploads/2025/06/20250605_VEOF_FMS-FORM_WORKING_Thang_05_2025_KY-SO_FOR-FILING.xlsx',
  },
  {
      "value": "VIBF",
      "label": "VIBF - Vina Capital",
      "id": 12,
      "created_at": "2025-01-06T07:45:37.283706+00:00",
      "fund_code": "VIBF",
      "fund_name": "Cân bằng Tuệ Sáng",
      "organization_name": "Vina Capital",
      "status": true,
      "total_asset": 453,
      "nav": 16207,
      "fee": 0.0175,
      "establish_date": "2/7/2019",
      "stt": 12,
      "url_data": 'https://vinacapital.com/wp-content/uploads/YYYY_UP/MM_UP/YYYYMMDD_UP_VIBF_FMS_FORM_WORKING_Ky-so_Thang_MM_BCYYYY_BC.xlsx',
      "url_data_ex": 'https://vinacapital.com/wp-content/uploads/2025/06/20250605_VIBF_FMS_FORM_WORKING_Ky-so_Thang_052025.xlsx',
  },
  {
      "value": "VMEEF",
      "label": "VMEEF - Vina Capital",
      "id": 11,
      "created_at": "2025-01-06T07:45:37.283706+00:00",
      "fund_code": "VMEEF",
      "fund_name": "CP Kinh tế hiện đại",
      "organization_name": "Vina Capital",
      "status": false,
      "total_asset": 156,
      "nav": 12891,
      "fee": 0.0175,
      "establish_date": "4/5/2023",
      "stt": 13
  },
  {
      "value": "FUEVN100",
      "label": "FUEVN100 - Vina Capital",
      "id": 13,
      "created_at": "2025-01-06T07:45:37.283706+00:00",
      "fund_code": "FUEVN100",
      "fund_name": "Hoán đổi danh mục VN100",
      "organization_name": "Vina Capital",
      "status": false,
      "total_asset": 438,
      "nav": 17800,
      "fee": 0.0067,
      "establish_date": "16/06/2020",
      "stt": 14
  }
]